"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var colors_1 = require("./colors");

var polished_1 = require("polished");

var themes_1 = require("./themes");

var utils_1 = require("./utils");

exports.Button = styled_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  background-color: ", ";\n  border: ", ";\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  cursor: pointer;\n  transition: all 0.2s;\n  border-radius: ", ";\n  white-space: nowrap;\n  margin: ", ";\n  padding: ", ";\n  font: ", ";\n  font-size: ", ";\n  line-height: normal;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &:hover {\n    background-color: ", ";\n    border-color: ", ";\n  }\n\n  svg {\n    margin-right: 10px;\n  }\n"], ["\n  color: ", ";\n  background-color: ", ";\n  border: ", ";\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  cursor: pointer;\n  transition: all 0.2s;\n  border-radius: ", ";\n  white-space: nowrap;\n  margin: ", ";\n  padding: ", ";\n  font: ", ";\n  font-size: ", ";\n  line-height: normal;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &:hover {\n    background-color: ", ";\n    border-color: ", ";\n  }\n\n  svg {\n    margin-right: 10px;\n  }\n"])), function (props) {
  return colors_1.getColor(props);
}, function (props) {
  return colors_1.getBackgroundColor(props);
}, function (_a) {
  var border = _a.border,
      raised = _a.raised,
      theme = _a.theme,
      primary = _a.primary,
      secondary = _a.secondary;
  return border || raised ? "2px solid " + colors_1.getColor({
    theme: theme,
    primary: primary,
    secondary: secondary
  }) : '2px solid transparent';
}, utils_1.getBorderRadius('button'), function (_a) {
  var margin = _a.margin;
  return margin ? margin : '0';
}, function (_a) {
  var theme = _a.theme,
      size = _a.size;

  var _b, _c, _d, _e, _f, _g;

  return (_d = utils_1.getFactor(size) * ((_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.button) === null || _c === void 0 ? void 0 : _c.paddingVertical), _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.button.paddingVertical) + "px " + (_g = utils_1.getFactor(size) * ((_f = (_e = theme) === null || _e === void 0 ? void 0 : _e.button) === null || _f === void 0 ? void 0 : _f.paddingHorizontal), _g !== null && _g !== void 0 ? _g : themes_1.defaultTheme.button.paddingHorizontal) + "px";
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.button) === null || _c === void 0 ? void 0 : _c.font, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.button.font;
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d, _e, _f;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.button) === null || _c === void 0 ? void 0 : _c.fontSize, _d !== null && _d !== void 0 ? _d : (_f = (_e = themes_1.defaultTheme) === null || _e === void 0 ? void 0 : _e.button) === null || _f === void 0 ? void 0 : _f.fontSize;
}, function (props) {
  return props.raised ? polished_1.darken(0.1, colors_1.getBackgroundColor(props)) : props.background || 'rgba(0, 0, 0, 0.1)';
}, function (props) {
  return props.raised || props.border ? polished_1.darken(0.1, colors_1.getBackgroundColor(props)) : props.background || 'rgba(0, 0, 0, 0.1)';
});
exports.IconButton = styled_1.default(exports.Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: ", "px;\n\n  svg {\n    margin-right: 0;\n  }\n"], ["\n  padding: ", "px;\n\n  svg {\n    margin-right: 0;\n  }\n"])), function (_a) {
  var theme = _a.theme,
      size = _a.size;

  var _b, _c, _d;

  return utils_1.getFactor(size) * (_d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.button) === null || _c === void 0 ? void 0 : _c.paddingVertical, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.button.paddingVertical);
});
var templateObject_1, templateObject_2;